module.exports = __webpack_public_path__ + "img/user.8f596cb0.png";